module.exports = __webpack_public_path__ + "static/estamparia-7a11913cfa53de48f239d02552f486f5.png";